import { Notification } from "types/notificatonTypes";
import { createMockListPage } from "./listingMocks";
import { demoApi } from "./demoLocale";

export const mockNotifications: Notification[] = [
  {
    NotificationId: "00000000-0000-0000-0000-000000000e01",
    Description: "Nowy zawodnik dołączył do grupy Pierwsza drużyna",
    IsComplete: true,
    IsSee: false,
    SentAt: "2026-07-08T09:15:00Z",
    TypeObjectId: "00000000-0000-0000-0000-000000000101",
    Type: 29,
    Name: "Jan Kowalski",
  },
  {
    NotificationId: "00000000-0000-0000-0000-000000000e02",
    Description: "Zaplanowano nowe wydarzenie: Trening techniczny",
    IsComplete: true,
    IsSee: true,
    SentAt: "2026-07-07T14:30:00Z",
    TypeObjectId: "00000000-0000-0000-0000-000000000301",
    Type: 19,
    Name: "Trening techniczny",
  },
  {
    NotificationId: "00000000-0000-0000-0000-000000000e03",
    Description: "Nowe zamówienie w sklepie — ORD/2026/001",
    IsComplete: false,
    IsSee: false,
    SentAt: "2026-07-06T11:00:00Z",
    TypeObjectId: "00000000-0000-0000-0000-000000000401",
    Type: 14,
    Name: "Anna Kowalska",
  },
];

export const getMockNotificationsPage = demoApi((pageInfo: any) =>
  createMockListPage(
    mockNotifications,
    pageInfo,
    (notification, search) =>
      notification.Description.toLowerCase().includes(search) ||
      (notification.Name?.toLowerCase().includes(search) ?? false)
  ));

export const getMockCompleteNotificationsPage = demoApi((pageInfo: any) =>
  createMockListPage(
    mockNotifications.filter((n) => n.IsComplete),
    pageInfo,
    (notification, search) => notification.Description.toLowerCase().includes(search)
  ));

export const getMockSeenNotificationsPage = demoApi((pageInfo: any) =>
  createMockListPage(
    mockNotifications.filter((n) => n.IsSee),
    pageInfo,
    (notification, search) => notification.Description.toLowerCase().includes(search)
  ));
